import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import GetUsersPerCountryBars from './ReportsSections/GetUsersPerCountryBars';
import SecondaryButton from '../../components/ui/SecondaryButton';
import TotalSalesTab from './ReportsSections/TotalSalesTab';
import TotalRevenueTab from './ReportsSections/TotalRevenueTab';
import SessionCountChart from './ReportsSections/SessionCountChart';
import RealtimeReportTab from './ReportsSections/RealtimeReportTab';
import UserEngagementDurationChart from './ReportsSections/UserEngagementDurationChart';
import AveragePurchaseRevenuePerUserChart from './ReportsSections/AveragePurchaseRevenuePerUserChart';
import NewUsersTab from './ReportsSections/NewUsersTab';
import DeviceModelBars from './ReportsSections/DeviceModelBars';
import ChartOne from './ReportsSections/ChartOne';
import Datepicker from 'react-tailwindcss-datepicker';





const dayJsDateSubtract = (dayToSubtract) => {
  const today = dayjs()
  return today.subtract(dayToSubtract, "day").startOf("day").toDate()
}

const dateRangeConverter = ({ startDate, endDate }) => {

  const dateRangeStart = dayjs(startDate).format('YYYY-MM-DD')
  const dateRangeEnd = dayjs(endDate).format('YYYY-MM-DD')


  return { startDate: dateRangeStart, endDate: dateRangeEnd }
}



const ReportsStage = () => {
  const defaultDateRanges = {
    todayCustom: {
      text: "Bugün",
      period: {
        start: dayJsDateSubtract(0),
        end: dayJsDateSubtract(0)
      }
    },
    yesterdayCustom: {
      text: "Dün",
      period: {
        start: dayJsDateSubtract(1),
        end: dayJsDateSubtract(1)
      }
    },
    last7Days: {
      text: "Son 7 Gün",
      period: {
        start: dayJsDateSubtract(6),
        end: dayJsDateSubtract(0)
      }
    },
    last15Days: {
      text: "Son 15 Gün",
      period: {
        start: dayJsDateSubtract(14),
        end: dayJsDateSubtract(0)
      }
    },
    last30Days: {
      text: "Son 30 Gün",
      period: {
        start: dayJsDateSubtract(29),
        end: dayJsDateSubtract(0)
      }
    }
  }
  const initialStartDate = defaultDateRanges.last30Days.period.start
  const initialEndDate = defaultDateRanges.last30Days.period.end
  const [dateRange, setDateRange] = useState({ startDate: initialStartDate, endDate: initialEndDate });

  return (
    <div className="flex w-[100%] relative text-[#212121] overflow-auto h-full relative ">
      <div className="flex w-[75%] flex-col p-[20px] pb-[20px] 2lx:pb-[40px]">
        <div className="flex gap-[12px] w-[100%]  p-[10px] mb-[10px] flex-row items-center">



          <div className='ml-auto'>

            Tarih Aralığı Seçiniz:
          </div>
          <div className='max-w-[500px] '>
            <Datepicker
              i18n={"tr"}

              displayFormat='YYYY-MM-DD'
              configs={{
                shortcuts: defaultDateRanges,
              }}
              startWeekOn="mon"
              value={dateRange}
              primaryColor={"purple"}
              onChange={newValue => setDateRange(newValue)}
              showShortcuts={true}
            />
          </div>
        </div>

        <div className="flex flex-row w-[100%] max-h-max border rounded-[10px] bg-white overflow-x-auto mb-[30px]  min-h-[116px]">
          <div className="w-[33%]">
            <TotalRevenueTab dateRange={dateRangeConverter(dateRange)} />
          </div>
          <div className="w-[33%]">
            <TotalSalesTab dateRange={dateRangeConverter(dateRange)} />
          </div>
          <div className="w-[33%]">
            <NewUsersTab dateRange={dateRangeConverter(dateRange)} />
          </div>
        </div>

        <div className="w-[100%] rounded-[10px] flex gap-[30px] mb-[30px]">
          <div className="w-[33%] rounded-[10px] bg-white p-[10px] flex flex-col gap-[10px] align-items-center">
            <SessionCountChart dateRange={dateRangeConverter(dateRange)} />
          </div>
          <div className="w-[33%] rounded-[10px] bg-white p-[10px] flex flex-col gap-[10px] align-items-center">
            <UserEngagementDurationChart dateRange={dateRangeConverter(dateRange)} />
          </div>
          <div className="w-[33%] rounded-[10px] bg-white p-[10px] flex flex-col gap-[10px] align-items-center">
            <AveragePurchaseRevenuePerUserChart dateRange={dateRangeConverter(dateRange)} />
          </div>
        </div>
        <div className="w-[100%] rounded-[10px] flex gap-[30px] mb-[30px]">
          <div className="w-[33%] min-h-[415px] rounded-[10px] bg-white  flex flex-col gap-[10px] align-items-center">
            <ChartOne dateRange={dateRangeConverter(dateRange)} />
          </div>
          <div className="w-[33%] min-h-[415px] rounded-[10px] bg-white flex flex-col gap-[10px] align-items-center">
            <GetUsersPerCountryBars dateRange={dateRangeConverter(dateRange)} />
          </div>
          <div className="w-[33%] min-h-[415px] rounded-[10px] bg-white flex flex-col gap-[10px] align-items-center">
            <DeviceModelBars dateRange={dateRangeConverter(dateRange)} />
          </div>
        </div>
      </div>
      <div className="flex w-[25%] flex-col p-[20px] pb-[20px] 2lx:pb-[40px]">
        <div className="flex gap-[12px] w-[100%]  p-[10px] overflow-x-auto mb-[10px] invisible">
          <SecondaryButton
            classes="bg-[#7059EF] hover:bg-[#5841D9] text-[#FFFFFF] py-2 px-4 rounded-[10px] text-[17px] font-medium w-[150px] cursor-pointer"
            onClick={() => {
              console.log('');
            }}
            value={'iOS, Android'}
          />
        </div>

        <div className="flex flex-row w-[100%] max-h-max border rounded-[10px] bg-white overflow-x-auto mb-[30px] min-h-[116px]">
          <div className="w-[100%] flex align-items-center">
            <RealtimeReportTab />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsStage;
